import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { X } from "lucide-react";
import { GREEN_CLOSE_BTN } from "../../../../../assets";

interface PaymentModalProps {
  open: boolean;
  close: () => void;
  onPay: () => void;
}

const PaymentModal: React.FC<PaymentModalProps> = ({ open, close, onPay }) => {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[428px]"
      edges="rounded-2xl"
    >
      <div className="flex flex-col w-full items-end bg-white p-8 relative">
        {/* Close Button */}
        <button
          onClick={close}
          className="p-1 rounded-full  hover:bg-gray-100 transition-colors"
        >
          <img src={GREEN_CLOSE_BTN} className="w-[17px] h-[17px]" alt="" />
        </button>

        <h2 className="text-xl font-bold text-[#1A1A1A] w-full text-center mb-8">
          Enter card details
        </h2>

        <div className="flex flex-col gap-y-6 w-full">
          <input
            type="text"
            placeholder="Card number"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-[#1A1A1A] placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
          />

          <input
            type="text"
            placeholder="Card holders name"
            className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-[#1A1A1A] placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
          />

          <div className="flex gap-x-4 w-full">
            <input
              type="text"
              placeholder="MM/YYYY"
              className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-[#1A1A1A] placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
            />
            <input
              type="text"
              placeholder="CVV"
              className="w-full px-4 py-3 border border-[#D0D5DD] rounded-lg text-[#1A1A1A] placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
            />
          </div>

          <button
            onClick={onPay}
            className="w-full bg-[#00B074] text-white py-4 rounded-lg font-medium text-lg hover:bg-[#009b65] transition-colors mt-2"
          >
            Pay now
          </button>
        </div>
      </div>
    </ModalV2>
  );
};

export default PaymentModal;
